"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: "24px",
    width: "24px"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.56,8.49h.55A9.19,9.19,0,0,1,17,8.06V7.85h0V7.09a8.93,8.93,0,0,1-3.46.54,8.84,8.84,0,0,1-3.45-.54v.76C10.15,8.07,11.4,8.49,13.56,8.49Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.56,5.9c2.16,0,3.42-.42,3.46-.65V4.5A9.12,9.12,0,0,1,13.56,5a9,9,0,0,1-3.45-.54v.76C10.15,5.48,11.4,5.9,13.56,5.9Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.11,9.14c0,.21,1.13.59,3,.64V9.57a.89.89,0,0,1,.27-.64,8.86,8.86,0,0,1-3.29-.54Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.56,4.61C15.72,4.61,17,4.18,17,4c0-.74-1.79-1.08-3.46-1.08S10.11,3.22,10.11,4C10.15,4.18,11.4,4.61,13.56,4.61Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.56,7.2c2.16,0,3.42-.43,3.46-.65V5.8a9.12,9.12,0,0,1-3.46.54,9,9,0,0,1-3.45-.54v.75C10.15,6.77,11.4,7.2,13.56,7.2Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.11,10.44c0,.68,1.49,1,3,1.07V10.22a8.08,8.08,0,0,1-3-.53Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.56,9.57c.08.22,1.49.65,3.46.65s3.36-.42,3.45-.65c0-.93-2.51-1.08-3.45-1.08S13.56,8.65,13.56,9.57Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.56,11.39v.78c0,.93,2.52,1.08,3.46,1.08s3.45-.15,3.45-1.08v-.78A9.51,9.51,0,0,1,17,12,9.53,9.53,0,0,1,13.56,11.39Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17,10.65a9.73,9.73,0,0,1-3.46-.55v.77c.08.22,1.49.65,3.46.65s3.37-.43,3.45-.66V10.1A9.71,9.71,0,0,1,17,10.65Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    y: "11.25",
    width: "4",
    height: "9",
    rx: "0.5",
    ry: "0.5",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.85,15.39a3.24,3.24,0,0,0-3.51-1.12l-3,1a2.42,2.42,0,0,1-2.33,3H10a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h5a1.37,1.37,0,0,0,1.38-1.5A1.38,1.38,0,0,0,15,14.25H12a.51.51,0,0,1-.35-.15A5.8,5.8,0,0,0,7.5,12.25h-2a.5.5,0,0,0-.5.5v5.5a.51.51,0,0,0,.34.47c1.56.52,3.28,1,4.26,1.32a12.94,12.94,0,0,0,4,1.08c1.95,0,3.39-1.54,10.15-4.93A.5.5,0,0,0,23.85,15.39Z",
    fill: "#004864"
  }));
};

exports["default"] = _default;